<!-- 查询线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "buyMethod":0,
                "carNo":"粤A12345",
                "pageNum":1,
                "pageSize":10,
                "parkCodeList":[
                    "2KKN6112",
                    "2KKN885S"
                ],
                "validFrom": "20210401000000",
                "validTo": "20210430235959",
                "validStatus":0
            },
            responseCode: {
                "data": {
                    "recordList": [
                        {
                            "actualValue": 28,
                            "availableValue": 0,
                            "buyMethod": 0,
                            "buyMethodName": "后台添加",
                            "carCode": "粤E78787",
                            "configStatus": 1,
                            "createBy": "zengxy",
                            "createTime": 1619363860000,
                            "depositValue": 0,
                            "dynamicCarportNumber": 1,
                            "endRenewTime": 7930713600000,
                            "id": 1000535465,
                            "inviteCarCurrentCount": 0,
                            "isZeroClean": 0,
                            "monthTicketId": 1000001882,
                            "parkNameList": "智泊云开发测试车场",
                            "parkSysType": 1,
                            "price": "30.00",
                            "reliefValue": 2,
                            "remark1": "",
                            "remark2": "",
                            "remark3": "",
                            "renew": 0,
                            "renewFormerDays": 0,
                            "renewMethod": 1,
                            "renewStr": "不允许",
                            "settlementType": 0,
                            "supportVirtualCarcode": 0,
                            "ticketCode": "2021042314252397071477",
                            "ticketName": "后台可用金额优惠自定义",
                            "ticketType": 0,
                            "timeperiodList": [
                            {
                            "startTime": "20201203000000",
                            "endTime": "20210102235959"
                            }
                            ],
                            "topBillCode": "2021042523174029571568",
                            "totalValue": 30,
                            "updateBy": "zengxy",
                            "updateTime": 1619363860000,
                            "userName": "西喜爱",
                            "userPhone": "18783748777",
                            "validStatus": 0
                        }
                    ],
                    "total": 1,
                    "currCount": 1
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询线上月票记录",
                t_url: this.commonUrls.test + "getOnlineMonthTicketList",
                p_url: this.commonUrls.prod + "getOnlineMonthTicketList",
                precondition: "无",
                fitSystem: "云停车场，传统停车场（线上开通的月票）",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'JSONArray', info4: '停车场编号列表' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码' },
                        { info1: 'userUniqCode', info2: '否', info3: 'String', info4: '用户唯一编码' },
                        // { info1: 'ticketName', info2: '否', info3: 'String', info4: '月票名称' },
                        // { info1: 'ticketType', info2: '否', info3: 'Integer', info4: '月票类型, 0对内 1对外' },
                        { info1: 'buyMethod', info2: '否', info3: 'Integer', info4: '月票购买方式, 0后台添加 1自行购买 2第三方添加' },
                        { info1: 'validStatus', info2: '否', info3: 'Integer', info4: '有效状态, 1 生效中，2已退款，3未生效，4已过期/已失效' },
                        { info1: 'validFrom', info2: '否', info3: 'String', info4: '月票有效起始时间，yyyyMMddHHmmss' },
                        { info1: 'validTo', info2: '否', info3: 'String', info4: '月票有效结束时间，yyyyMMddHHmmss' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多100条' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '月票列表' },
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '总张数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前张数' },
                    ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '月票id' },
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型id' },
                        { info1: 'topBillCode', info2: '是', info3: 'String', info4: '月票流水号' },
                        { info1: 'ticketName', info2: '是', info3: 'String', info4: '月票名称' },
                        { info1: 'ticketType', info2: '是', info3: 'Integer', info4: '月票类型, 0对内 1对外' },
                        { info1: 'ticketCode', info2: '是', info3: 'Integer', info4: '月票编号' },
                        { info1: 'userName', info2: '是', info3: 'String', info4: '车主' },
                        { info1: 'userPhone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号，支持多个逗号分隔,展示用' },
                        { info1: 'price', info2: '是', info3: 'Decimal', info4: '单价' },
                        { info1: 'totalValue', info2: '是', info3: 'Decimal', info4: '总金额' },
                        { info1: 'actualValue', info2: '是', info3: 'Decimal', info4: '实付金额' },
                        { info1: 'reliefValue', info2: '是', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'refundValue', info2: '是', info3: 'Decimal', info4: '退款金额' },
                        { info1: 'endRenewTime', info2: '是', info3: 'String', info4: '车主截止续费时间，yyyyMMddHHmmss' },
                        { info1: 'validStatus', info2: '是', info3: 'Integer', info4: '有效状态, 0 不在有效期，1 生效中，2已退款，3未生效，4已过期/已失效' },
                        { info1: 'payStatus', info2: '是', info3: 'Integer', info4: '付款状态，0已付款，1已退款' },
                        { info1: 'createBy', info2: '是', info3: 'String', info4: '创建人' },
                        { info1: 'createTime', info2: '是', info3: 'String', info4: '开通时间，yyyyMMddHHmmss' },
                        { info1: 'updateBy', info2: '是', info3: 'String', info4: '修改操作人' },
                        { info1: 'updateTime', info2: '是', info3: 'String', info4: '修改操作时间，yyyyMMddHHmmss' },
                        { info1: 'inviteCarCurrentCount', info2: '是', info3: 'Integer', info4: '邀请车牌总数量' },
                        { info1: 'dynamicCarportNumber', info2: '是', info3: 'Integer', info4: '该月票开通多少车位' },
                        { info1: 'renew', info2: '是', info3: 'Integer', info4: '是否允许续费 ，0=不允许，1=允许，默认=1' },
                        { info1: 'sendStatus', info2: '是', info3: 'Integer', info4: '发送状态 0未发送，1发送中，2发送成功，3发送失败' },
                        { info1: 'carNoNum', info2: '是', info3: 'Integer', info4: '该月票开通的车牌数量' },
                        { info1: 'parkSysType', info2: '是', info3: 'Integer', info4: '停车场系统类型, 0 传统停车场, 1 云停车场' },
                        { info1: 'buyMethod', info2: '是', info3: 'Integer', info4: '月票购买方式（0:后台添加;1:自行购买;2:第三方添加）' },
                        // { info1: 'parkCodes', info2: '是', info3: 'String', info4: '停车场编号列表，需与线上月票类型权限的parkCodes完全一致方可创建' },
                        { info1: 'timePeriodList', info2: '是', info3: 'JSONArray', info4: '月票有效期' },
                        { info1: 'configStatus', info2: '是', info3: 'Integer', info4: '月票状态，0未上架，1已上架' },
                        { info1: 'settlementType', info2: '是', info3: 'Integer', info4: '结算类型 0时间结算，1储值结算，2储次结算 3储时结算' },
                        { info1: 'renewMethod', info2: '是', info3: 'Integer', info4: '续费方式，对内月票才有，0自然月，1自定义' },
                        { info1: 'renewFormerDays', info2: '是', info3: 'Integer', info4: '向前续费天数，0表示不允许向前续费，旧数据默认是0' },
                        { info1: 'inviteCarTotal', info2: '是', info3: 'Integer', info4: '允许邀请车牌的总数量' },
                        { info1: 'supportVirtualCarNo', info2: '是', info3: 'Integer', info4: '支持虚拟车牌,0=不支持，1=支持，虚拟车牌与实体车牌互斥' },
                        { info1: 'remark1', info2: '是', info3: 'String', info4: '备注1' },
                        { info1: 'remark2', info2: '是', info3: 'String', info4: '备注2' },
                        { info1: 'remark3', info2: '是', info3: 'String', info4: '备注3' },
                        { info1: 'depositValue', info2: '否', info3: 'Decimal', info4: '充值总额' },
                        { info1: 'availableValue', info2: '否', info3: 'Decimal', info4: '剩余可用额度' },
                        { info1: 'isZeroClean', info2: '否', info3: 'Integer', info4: '余值清零月票身份无效 0:不清  1:金额为0时,失效' },
						{ info1: 'isFrozen', info2: '是', info3: 'Integer', info4: '是否冻结0否，1即将，2冻结' },
						{ info1: 'frozenTime', info2: '否', info3: 'String', info4: '冻结时间' },
						{ info1: 'resendNum', info2: '否', info3: 'Integer', info4: '重发次数' },
						{ info1: 'syncTime', info2: '否', info3: 'String', info4: '同步时间' },

					   ]
                },{
                    titleName: 'timePeriodList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间，yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，yyyyMMddHHmmss' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getOnlineMonthTicketList.vue